// components/atoms/PayPalMessage.tsx

import { loadPayPalScriptSingleton } from '@utils/paypal-script-singleton'
import React, { useEffect, useRef } from 'react'

interface PayPalMessageProps {
  amount: number
  className?: string
}

const PayPalMessage: React.FC<PayPalMessageProps> = ({ amount, className }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const renderPayPalMessage = async () => {
      const container = containerRef.current
      if (!container || amount <= 0) return

      try {
        const paypal = await loadPayPalScriptSingleton()

        if (paypal?.Messages) {
          // render() is idempotent: calling it again with same container just updates it
          paypal.Messages({ amount }).render(container)
        }
      } catch (error) {
        console.error('Failed to render PayPal message:', error)
      }
    }

    renderPayPalMessage()

    // cleanup: just reset state, don’t nuke the DOM
    return () => {
      // do not touch container.innerHTML
    }
  }, [amount])

  return (
    <div
      ref={containerRef}
      className={className}
      data-pp-message
      data-pp-style-layout="text"
      data-pp-style-logo-type="inline"
      data-pp-style-text-color="black"
      data-pp-style-text-size="12"
      data-pp-placement="product"
    />
  )
}

export default PayPalMessage
